/* eslint-disable import/no-default-export */
import React from 'react';
import ReactDOM from 'react-dom';

import styles from './layer-manager.less';

const LayerManagerContext = React.createContext({
  alertLayerRef: React.createRef<HTMLDivElement>(),
  overlayLayerRef: React.createRef<HTMLDivElement>(),
  popoverLayerRef: React.createRef<HTMLDivElement>(),
  tooltipLayerRef: React.createRef<HTMLDivElement>(),
});

type Ref = React.RefObject<HTMLDivElement>;

interface LayerManagerRefs {
  alertLayerRef: Ref;
  overlayLayerRef: Ref;
  popoverLayerRef: Ref;
  tooltipLayerRef: Ref;
}

export default class LayerManager extends React.Component {
  layerRefs: LayerManagerRefs = {
    alertLayerRef: React.createRef<HTMLDivElement>(),
    overlayLayerRef: React.createRef<HTMLDivElement>(),
    popoverLayerRef: React.createRef<HTMLDivElement>(),
    tooltipLayerRef: React.createRef<HTMLDivElement>(),
  };

  render() {
    return (
      <LayerManagerContext.Provider value={this.layerRefs}>
        <div className={styles.appLayer}>{this.props.children}</div>
        {/*
         * Wrap these elements in a parent with the magic class that suppresses
         * the global click-handling logic (see doc-init.js#domReady method)
         */}
        <div className="js-react-root">
          <div
            className={styles.alertLayer}
            ref={this.layerRefs.alertLayerRef}
          />
          <div
            className={styles.overlayLayer}
            ref={this.layerRefs.overlayLayerRef}
          />
          <div
            tabIndex={-1}
            className={styles.popoverLayer}
            ref={this.layerRefs.popoverLayerRef}
          />
          <div
            className={styles.tooltipLayerRef}
            ref={this.layerRefs.tooltipLayerRef}
          />
        </div>
      </LayerManagerContext.Provider>
    );
  }
}

export enum Layers {
  Alert,
  Overlay,
  Popover,
  Tooltip,
}

interface LayerManagerPortalProps {
  layer: Layers;
}

export class LayerManagerPortal extends React.Component<
  LayerManagerPortalProps
> {
  render() {
    const { layer } = this.props;

    return (
      <LayerManagerContext.Consumer>
        {(refs) => {
          let ref: Ref;

          switch (layer) {
            case Layers.Alert:
              ref = refs.alertLayerRef;
              break;
            case Layers.Overlay:
              ref = refs.overlayLayerRef;
              break;
            case Layers.Popover:
              ref = refs.popoverLayerRef;
              break;
            case Layers.Tooltip:
              ref = refs.tooltipLayerRef;
              break;
            default:
              ref = refs.popoverLayerRef;
          }

          return ref.current
            ? ReactDOM.createPortal(this.props.children, ref.current)
            : null;
        }}
      </LayerManagerContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./app/gamma/src/components/layer-manager/index.tsx